<template>
  <div class="tradInstru">
    <p class="title">
      全城热浪平台旨在为用户提供一站式才艺课程，保障客户资金安全。
    </p>

    <div class="image_box">
      充值规则
    </div>

    <p class="text">
      平台只接受在客户端鱼池中进行充值，在鱼池中可以按照相应的金额进行充值，充值后可以在全平台进行消费、约课、上课，不限品类，不限课程。每个在经营的机构和老师都会有自己的排课时间表，默认每个陌生的用户都可以预约。
    </p>
    <p class="text">
      用户在商家进行充值则可以在订单详情中看见充值详情，在商家进行充值则之恶能预约该商家的老师和课程。
    </p>
    <p class="text" style="margin-bottom: 25px;">
      注：在商家进行充值，钱款会一次性结算给商家，平台将不提供资金安全保障。
    </p>

    <div class="image_box">
      平台服务
    </div>

    <p class="text">
      平台会根据老师的排课、学员数量、课程评价、课程价格等因素综合对老师进行排名，优质的老师课程会相对靠前。用户也可以根据老师的作品寻找自己喜欢的老师进行约课。
    </p>
  </div>
</template>

<script>
export default {
  name: 'tradInstru',
  mounted() {
    document.title = '平台交易说明'
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/css/flexable.scss';

.tradInstru {
  width: 100%;
  padding: px2rem(60) px2rem(42) 0;
  text-align: left;
  box-sizing: border-box;
  .title {
    margin-bottom: px2rem(50);
    font-size: px2rem(30);
    font-weight: 500;
    color: #1F1F1F;
    line-height: px2rem(44);
  }

  .image_box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    margin-bottom: px2rem(45);
    width: px2rem(240);
    font-size: px2rem(34);
    font-weight: bold;
    color: #1F1F1F;
    // background: url(../assets/icon100.png) no-repeat;
    // background-size: 100% 100%;
  }

  .text {
    font-size: 13px;
    font-weight: 500;
    color: #8D8D8D;
    line-height: 1.8em;
  }
}
</style>